import { useCallback, useRef, useState } from 'react';
import { CONSTANTS } from '../data.js';

export function useCookbookResize() {
  const [sidebarWidth, setSidebarWidth] = useState(CONSTANTS.COOKBOOK_SIDEBAR_DEFAULT_WIDTH);
  
  const resizerState = useRef<{ 
    active: boolean; 
    startX: number; 
    startWidth: number; 
    prevUserSelect: string 
  }>({
    active: false,
    startX: 0,
    startWidth: CONSTANTS.COOKBOOK_SIDEBAR_DEFAULT_WIDTH,
    prevUserSelect: 'auto'
  });

  const onPointerDown = useCallback((e: React.PointerEvent<HTMLDivElement>) => {
    e.preventDefault();
    resizerState.current.active = true;
    resizerState.current.startX = e.clientX;
    resizerState.current.startWidth = sidebarWidth;
    resizerState.current.prevUserSelect = document.body.style.userSelect;
    document.body.style.userSelect = 'none';

    const onMove = (ev: PointerEvent) => {
      if (!resizerState.current.active) return;
      ev.preventDefault();
      const dx = ev.clientX - resizerState.current.startX;
      let newWidth = resizerState.current.startWidth + dx;

      if (newWidth < CONSTANTS.COOKBOOK_SIDEBAR_MIN_WIDTH) {
        newWidth = CONSTANTS.COOKBOOK_SIDEBAR_MIN_WIDTH;
      }
      if (newWidth > CONSTANTS.COOKBOOK_SIDEBAR_MAX_WIDTH) {
        newWidth = CONSTANTS.COOKBOOK_SIDEBAR_MAX_WIDTH;
      }

      setSidebarWidth(newWidth);
    };

    const end = (ev: PointerEvent) => {
      ev.preventDefault();
      resizerState.current.active = false;
      document.body.style.userSelect = resizerState.current.prevUserSelect;
      window.removeEventListener('pointermove', onMove);
      window.removeEventListener('pointerup', end);
      window.removeEventListener('pointercancel', end);
    };

    window.addEventListener('pointermove', onMove, { passive: false });
    window.addEventListener('pointerup', end, { passive: false });
    window.addEventListener('pointercancel', end, { passive: false });
  }, [sidebarWidth]);

  return { sidebarWidth, onPointerDown };
}
